import clsx from 'clsx';
import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import { SDSPrimitiveButton } from '@repo/sds/SDSPrimitiveButton';
import { SDSText } from '@repo/sds/SDSText';

import './SidebarItem.scss';

interface SidebarItemProps {
  icon: ReactNode;
  title: string;
  path: string;
  chip?: ReactNode;
  compressed?: boolean;
  disabled?: boolean;
  testid?: string;
}

export function SidebarItem({
  icon,
  title,
  path,
  chip,
  compressed = false,
  disabled = false,
  testid,
}: SidebarItemProps) {
  const location = useLocation();
  const isSelected = location.pathname.startsWith(path);

  const rootClassName = clsx('SidebarItem', {
    'SidebarItem--selected': isSelected,
    'SidebarItem--disabled': disabled,
  });

  return (
    <SDSPrimitiveButton
      dataTestId={testid}
      className={rootClassName}
      href={disabled ? undefined : path}
      isDisabled={disabled}
    >
      <div className="SidebarItem__icon-box">{icon}</div>
      {!compressed && <SDSText text={title} type="button-small" align="center" />}
      {chip}
    </SDSPrimitiveButton>
  );
}
